import { CSSProperties, ReactNode } from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

import 'overlayscrollbars/overlayscrollbars.css';
import './styles.css';

type ScrollAreaProps = {
  className?: string;
  style?: CSSProperties;
  children: ReactNode | ReactNode[];
};

export function ScrollArea({ className, style, children }: ScrollAreaProps) {
  return (
    <OverlayScrollbarsComponent
      defer
      className={className}
      style={{ height: '100%', width: '100%', ...style }}
      options={{ scrollbars: { autoHide: 'scroll' } }}
    >
      {children}
    </OverlayScrollbarsComponent>
  );
}
